import type { VideoContentObject } from 'models';
import { Modal, getDateType, message } from 'ui';
import { useUpdateVideoMutation } from '../../../queries';
import { VideoEditForm, type VideoEditFormValues } from './video-edit-form';

type P = {
  isOpened: boolean;
  onClose: () => void;
  videoContentObject: VideoContentObject;
};

const VideoEditModal = ({ isOpened, onClose, videoContentObject }: P) => {
  const { isPending: isLoading, mutate: updateVideo } = useUpdateVideoMutation();

  const { video } = videoContentObject;

  const onSave = (values: VideoEditFormValues) => {
    updateVideo(
      {
        data: {
          coverPhoto: values.coverPhoto?.[0],
          featuredInChannels: values.featuredInChannels,
          htmlContent: values.htmlDescription,
          name: values.name,
          recordedAt: getDateType(values.recordedAt),
          showInChannels: values.showInChannels,
          tags: values.tags,
          textContent: values.textDescription,
        },
        id: video.id,
      },
      {
        onSuccess() {
          message.success('Video successfully edited');
          onClose();
        },
      },
    );
  };

  return (
    <Modal isOpened={isOpened} maskClosable={false} onCancel={onClose} title="Edit video" width="medium">
      <Modal.HugContent>
        <VideoEditForm isLoading={isLoading} onSuccess={onSave} videoContentObject={videoContentObject} />
      </Modal.HugContent>
    </Modal>
  );
};

export default VideoEditModal;
